import React, { useContext, useState } from 'react'
import axiosClient from '../../axios/axiosClient';
import AuthContext from '../../context/AuthContext';
import logo from "../../assets/images/fdo.png"
import Loader from '../../components/app/loader';
import { toast } from 'react-toastify';

function Login() {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const { login } = useContext(AuthContext);

    const handleLogin = (e) => {
        e.preventDefault();
        setLoading(true)
        axiosClient.post('/login', { email, password })
            .then((response) => {
                const res = response.data.data
                const { token,  data: user } = res;
                toast.success('Login Successful.');
                login(token, user);
                setLoading(false)
            })
            .catch((error) => {
                console.log(error.status)
                setLoading(false)
                toast.error('Login failed. Please check your credentials.');
            });
    };

    return (
        <>

         <div className="container-fluid p-0">
        <div className="authentication-main">
          <div className="row">
            <div className="col-md-12">
              <div className="auth-innerright">
                <div className="authentication-box">
                  <div className="text-center">
                    <img src={logo} alt="" style={{height:"50px"}} />
                  </div>
                  <div className="card mt-4">
                    <div className="card-body">
                    <>
                        <div className="text-center">
                            <h4>LOGIN</h4>
                            <h6>Enter your Username and Password </h6>
                        </div>
                        <form className="theme-form" onSubmit={handleLogin}>
                            <div className="mb-3">
                            <label className="col-form-label pt-0">Email</label>
                            <input className="form-control" type="email" required="" value={email}
                        onChange={(e) => setEmail(e.target.value)} />
                            </div>
                            <div className="mb-3">
                            <label className="col-form-label">Password</label>
                            <input className="form-control" type="password" required=""   value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        />
                            </div>
                            <div className="checkbox p-0">
                            <input id="checkbox1" type="checkbox" />
                            <label for="checkbox1">Remember me</label>
                            </div>
                            <div className="form-row mt-3">
                            <button className="btn btn-primary btn-block w-100" type="submit" disabled={loading}>Login</button>
                            </div>
                            {/* <div className="form-row mt-3">
                            <button className="btn btn-secondary btn-block w-100" type="submit">Login With Auth0</button>
                            </div> */}
                            {/* <div className="login-divider"></div> */}
                            {/* <div className="social mt-3">
                            <div className="form-group btn-showcase d-flex">
                                <button className="btn social-btn btn-fb d-inline-block"> <i className="fa fa-facebook"></i></button>
                                <button className="btn social-btn btn-twitter d-inline-block"><i className="fa fa-google"></i></button>
                                <button className="btn social-btn btn-google d-inline-block"><i className="fa fa-twitter"></i></button>
                                <button className="btn social-btn btn-github d-inline-block"><i className="fa fa-github"></i></button>
                            </div>
                            </div> */}
                        </form>
                        {loading && <Loader />}
                        </>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        </>
    )
}

export default Login
